import { Enum_Modules_Type } from '@graphql/generated/graphql';
import { StoryPageDisplay } from '@lib/pimster-stories/enums';
import { flow_renderers } from '@lib/pimster-stories/renderers';
import Story from '@lib/pimster-stories/Story';
import Survey from '@lib/pimster-surveys/Survey';
import { MultiPagesForm } from '@types';
import { FC } from 'react';

import { useFlow } from '../contexts/FlowContext';
import { FlowPage } from '../pages/components/FlowPage';
import { FlowPageProvider } from '../pages/contexts/FlowPageContext';

export const FlowRenderer: FC = () => {
    const { module, currentContent, triggerSource, onPrevious, onNext } =
        useFlow();

    if (!(module.Type === Enum_Modules_Type.Flow && currentContent)) {
        return null;
    }

    switch (currentContent.__typename) {
        case 'ComponentPagesFlowPage': {
            const flowPage = currentContent.FlowPage;

            if (!flowPage) return null;

            return (
                <FlowPageProvider key={flowPage.id} flowPage={flowPage}>
                    <FlowPage />
                </FlowPageProvider>
            );
        }

        case 'ComponentContentStory': {
            const story = currentContent.Story;

            if (!story) return null;

            return (
                <Story
                    key={story.id}
                    story={story}
                    renderers={[...flow_renderers]}
                    storyPageDisplay={StoryPageDisplay.Flow}
                />
            );
        }

        case 'ComponentFormsForm': {
            const survey = currentContent.Form;

            if (!survey) return null;

            return (
                <Survey
                    key={survey.id}
                    triggerSource={triggerSource}
                    survey={survey as MultiPagesForm}
                    methods={{
                        onSurveyQuit: onPrevious,
                        onSurveySuccess: onNext,
                    }}
                />
            );
        }

        default:
            return null;
    }
};
